<div class="login-container">
  <nav class="navbar">
    <div class="navbar-brand" (click)="goBackToPhoneInput()">
      <img src="assets/navbar logo.png" alt="Dashboard Logo" class="logo" />
      <h1>Utility Admin Panel</h1>
    </div>
  </nav>
  <div class="content-wrapper">
    <div class="logo-section">
      <img src="assets/Frame 129.png" alt="Hygge Energy Logo" class="main-logo" />
    </div>

    <div class="card">
      <div class="card-header">
        <img src="assets/hygge transparent (1).png" alt="Admin Icon" class="admin-icon" />
      </div>

      <div class="card-content">
        <!-- The form must be wrapped with [formGroup] directive -->
        <form class="form" *ngIf="!otp_requested" [formGroup]="reactiveForm">
          <div class="form-content">
            <h1>{{ headerLabel }}</h1>
            <p class="subtitle">
              {{ formLabel }}
            </p>
            <div class="input-group">
              <input 
                type="text" 
                id="login__enter-mobile-input" 
                formControlName="phone_number" 
                name="phone_number"
                placeholder="Enter 10-digit mobile number" 
                class="full-width-input spaced-input" 
                required
                pattern="[0-9]*" 
                inputmode="numeric" 
                autocomplete="new-password" 
                [maxLength]="maxPhoneDigits" 
                appOnlyNumber 
                (keyup.enter)="onPhoneNumberSubmit()" 
              />
            </div>
            
            <!-- Show validation error messages -->
            <div *ngIf="get_phone_number?.invalid && (get_phone_number?.dirty || get_phone_number?.touched)" class="error-message">
              <span *ngIf="get_phone_number?.errors?.['required']">Phone number is required</span>
              <span *ngIf="get_phone_number?.errors?.['pattern']">Please enter a 10-digit number</span>
            </div>
          </div>
          
          <button 
            type="button" 
            class="submit-button" 
            (click)="onPhoneNumberSubmit()" 
            [disabled]="is_loading || reactiveForm.get('phone_number')?.invalid"
          >
            <span *ngIf="!is_loading">Next</span>
            <span *ngIf="is_loading">Processing...</span>
          </button>
          
          <label *ngIf="phone_number_error" class="error-message">Please enter a valid 10-digit number</label>
          <label *ngIf="!is_authorized" class="error-message">Phone number is not authorized</label>
          <label *ngIf="max_attempts_reached" class="error-message">Reached max verification attempts</label>
          <label *ngIf="unexpected_error" class="error-message">Unexpected error please try later</label>
        </form>

        <!-- OTP form must also be wrapped with [formGroup] directive -->
        <form class="otp-form" *ngIf="otp_requested && is_authorized" [formGroup]="reactiveForm">
          <div class="form-content">
            <h1>Enter OTP</h1>
            <p class="subtitle">
              Enter the 6-digit OTP sent to your registered mobile number.
            </p>
            <div id="otp-inputs">
              <input 
                #otpInput 
                *ngFor="let otpPart of otpParts; let i = index; let isFirst = first; let isLast = last" 
                type="text" 
                [id]="otpPart" 
                class="otp-input" 
                [name]="otpPart" 
                placeholder=""
                min="0" 
                max="9" 
                required
                [formControlName]="otpPart" 
                autocomplete="new-password" 
                maxLength="1" 
                appOnlyNumber 
                pattern="[0-9]*" 
                inputmode="numeric" 
                (keyup)="onOtpInputKeyUp($event, isLast ? -1 : i+1, isFirst ? -1 : i-1)" 
                (keyup.enter)="onOtpSubmit()" 
              />
            </div>
            <label *ngIf="otp_error" class="error-message">Invalid OTP</label>
          </div>
          <div class="otp-buttons">
            <button 
              type="button" 
              class="submit-button" 
              (click)="onOtpSubmit()" 
              [disabled]="is_loading || !isOtpFormValid()"
            >
              <span *ngIf="!is_loading">Verify OTP</span>
              <span *ngIf="is_loading">Verifying...</span>
            </button>
            <button type="button" class="back-button" (click)="goBackToPhoneInput()">Enter Mobile Number</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>